import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface AddStudentToWaitlistParam {
  classId: string;
  studentId: string;
  priority: 'normal';
  notes: string;
}

export const addStudentToWaitlistAPI = async ({
  classId,
  ...params
}: AddStudentToWaitlistParam) => {
  const resp = await baseAPI.post<unknown>(
    `/waitlist/classes/${classId}/add-student`,
    {
      ...params,
    },
  );
  return resp.data;
};

export const useAddStudentToWaitlistMutation = () => {
  return useMutation({
    mutationFn: async (params: AddStudentToWaitlistParam) => {
      const response = await addStudentToWaitlistAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WAIT_LIST_SUMMARY, params.classId],
      });
      void queryClient.invalidateQueries({
        queryKey: ['classes', params.classId],
      });
    },
  });
};
